/* eslint-disable no-restricted-globals */
/* eslint-disable react/forbid-prop-types */
import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { useMutation, useQuery } from 'react-query';
import moment from 'moment';
import { showAlert } from '../../../../utilities/notifications';
import TermsCheckbox from '../../../../components/TermsCheckbox';
import { useSetting } from '../../../../utilities/sharedHooks/settings';
import ModalBodyLayout from '../../../shared/ModalBodyLayout';
import { LOANS_REQUEST } from '../../mutations';
import { LOANS_ALL } from '../../queries';
import { FLOWS, sendStats } from '../../../../services/mixpanel';
import { MXP_FTC_REQUEST_VISIT, MXP_FTC_REQUEST_CONTINUE } from '../../mixpanel-events';

const LoanTerms = ({ openScreen, screensKeys, calculatorForm, onHide }) => {
  const { t: translate } = useTranslation();

  const [termAndConditionChecked, setTermAndConditionChecked] = useState(false);
  useEffect(() => {
    sendStats(MXP_FTC_REQUEST_VISIT, {}, FLOWS.FTC);
  }, []);

  const { refetch: refetchAllLoans } = useQuery(LOANS_ALL, { enabled: false });

  const [contentUrlCryptodraftTerms] = useSetting('content_urls', 'content_url_loans_terms');

  const { mutate: requestLoan, isLoading } = useMutation(LOANS_REQUEST, {
    onSettled: (data, error) => {
      sendStats(MXP_FTC_REQUEST_CONTINUE, { data, error }, FLOWS.FTC);
      if (error) {
        showAlert({ message: error.message, type: 'danger' });
      } else {
        refetchAllLoans();
        showAlert({ message: translate('loan_request_success_msg'), type: 'success' });
        onHide();
      }
    },
  });

  const requestLoanHandler = (form) => {
    const today = moment(new Date());
    const dueDate = moment(new Date()).add(calculatorForm.loanLength, 'M');

    const payload = {
      LTV: form.ltv,
      interestApr: form.apr,
      collateralWalletAddress: form.collateralWallet.address,
      principalCurrency: form.principalWallet?.currency_code,
      collateralAmount: form.collateralAmount,
      collateralCurrency: calculatorForm?.collateralWallet?.coin,
      principalAmount: form.principalAmount,
      loanLengthDays: dueDate.diff(today, 'days'),
    };

    requestLoan(payload);
  };

  const renderFooter = () => (
    <button
      type="button"
      disabled={!termAndConditionChecked || isLoading}
      loading={isLoading ? 'true' : 'false'}
      className={`mb-4 btn modal__footer-btn py-3 ${
        termAndConditionChecked ? 'btn-primary' : 'btn-disabled'
      }`}
      onClick={() => {
        requestLoanHandler(calculatorForm);
      }}>
      {translate('loan_request_btn_title')}
    </button>
  );

  return (
    <ModalBodyLayout
      title={translate('cryptodraft_terms_title')}
      onPrevClick={() => openScreen(screensKeys.LOAN_OFFER)}
      renderFooter={renderFooter}
      withBack>
      <iframe
        className="p-0 w-100 mt-4"
        style={{
          minHeight: '30rem',
          overflowY: 'auto',
        }}
        title="terms and conditions"
        src={contentUrlCryptodraftTerms}
      />

      <div className="mt-2">
        <TermsCheckbox
          checked={termAndConditionChecked}
          onChange={() => setTermAndConditionChecked((prev) => !prev)}
          contentUrlKey="content_url_loans_terms"
        />
      </div>
    </ModalBodyLayout>
  );
};

export default LoanTerms;

LoanTerms.propTypes = {
  screensKeys: PropTypes.object.isRequired,
  calculatorForm: PropTypes.object.isRequired,
  openScreen: PropTypes.func.isRequired,
  onHide: PropTypes.func.isRequired,
};
